import { Injectable } from '@angular/core';
import { CanActivate,  UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class GuarddocentesGuard implements CanActivate {
  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    let rol = localStorage.getItem('rol');

      if(rol==="2"){
        return true;
      }
      return false;

  }

}
